import { configurePrivileges } from './configurePrivileges';
import { deleteRiskCaches } from './deleteRiskCaches';

export default {
  configurePrivileges,
  deleteRiskCaches
};
